/* HOROTROVE — theme behaviour */
(function () {
  'use strict';

  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  function initNav() {
    $$('.ht-nav__item--has-mega').forEach(function (item) {
      var btn = $('.ht-nav__link', item);
      var closeTimer;
      function open() { clearTimeout(closeTimer); item.classList.add('is-open'); if (btn) btn.setAttribute('aria-expanded', 'true'); }
      function close() { item.classList.remove('is-open'); if (btn) btn.setAttribute('aria-expanded', 'false'); }
      item.addEventListener('mouseenter', open);
      item.addEventListener('mouseleave', function () { closeTimer = setTimeout(close, 120); });
      if (btn) {
        btn.addEventListener('click', function (e) { e.preventDefault(); item.classList.contains('is-open') ? close() : open(); });
        btn.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
      }
      document.addEventListener('click', function (e) { if (!item.contains(e.target)) close(); });
    });
  }

  function initDrawer() {
    var drawer = $('#HtDrawer');
    var scrim = $('#HtDrawerScrim');
    if (!drawer) return;
    function open() { drawer.classList.add('is-open'); if (scrim) scrim.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
    function close() { drawer.classList.remove('is-open'); if (scrim) scrim.classList.remove('is-open'); document.body.style.overflow = ''; }
    $$('[data-ht-drawer-open]').forEach(function (b) { b.addEventListener('click', open); });
    $$('[data-ht-drawer-close]').forEach(function (b) { b.addEventListener('click', close); });
    if (scrim) scrim.addEventListener('click', close);
    $$('[data-ht-drawer-sub]').forEach(function (b) {
      b.addEventListener('click', function () {
        var panel = b.nextElementSibling;
        if (panel) panel.classList.toggle('is-open');
      });
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  }

  function initAccordions() {
    $$('.ht-acc__btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var acc = btn.closest('.ht-acc');
        if (!acc) return;
        var open = acc.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }

  function initGallery() {
    var main = $('#HtGalleryMain');
    if (!main) return;
    $$('.ht-gallery__thumb').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var src = thumb.getAttribute('data-full');
        var alt = thumb.getAttribute('data-alt') || '';
        if (src) { main.setAttribute('src', src); main.setAttribute('alt', alt); main.removeAttribute('srcset'); }
        $$('.ht-gallery__thumb').forEach(function (t) { t.setAttribute('aria-current', 'false'); });
        thumb.setAttribute('aria-current', 'true');
      });
    });
  }

  var modalRoot, modalBody, lastFocus;

  function openModal(html) {
    modalRoot = modalRoot || $('#HtModalRoot');
    modalBody = modalBody || $('#HtModalBody');
    if (!modalRoot || !modalBody) return;
    lastFocus = document.activeElement;
    modalBody.innerHTML = html;
    modalRoot.hidden = false;
    document.body.style.overflow = 'hidden';
    bindOfferUI(modalBody);
    bindFormUI(modalBody);
    var firstInput = modalBody.querySelector('input, button, select');
    if (firstInput) firstInput.focus();
  }

  function closeModal() {
    if (!modalRoot) return;
    modalRoot.hidden = true;
    modalBody.innerHTML = '';
    document.body.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function initModal() {
    modalRoot = $('#HtModalRoot');
    modalBody = $('#HtModalBody');
    if (!modalRoot) return;
    $$('[data-ht-modal-close]').forEach(function (b) { b.addEventListener('click', closeModal); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !modalRoot.hidden) closeModal(); });

    $$('[data-ht-modal-open]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var tplId = btn.getAttribute('data-ht-modal-open');
        var tpl = document.getElementById(tplId);
        if (tpl) openModal(tpl.innerHTML);
      });
    });
  }

  function money(n, symbol) {
    return (symbol || '$') + Math.round(n).toLocaleString('en-US');
  }

  function bindOfferUI(scope) {
    var wrap = scope.querySelector('[data-ht-offer]');
    if (!wrap) return;

    var market = parseFloat(wrap.getAttribute('data-market')) || 0;
    var symbol = wrap.getAttribute('data-symbol') || '$';
    var step = Math.max(1, Math.round(market * 0.005));
    var value = parseFloat(wrap.getAttribute('data-start')) || Math.round(market * 0.99);

    var amountEl = wrap.querySelector('[data-ht-offer-amount]');
    var pctEl = wrap.querySelector('[data-ht-offer-pct]');
    var strengthEl = wrap.querySelector('[data-ht-offer-strength]');
    var meterEl = wrap.querySelector('[data-ht-offer-meter] span');
    var hidden = wrap.querySelector('[data-ht-offer-input]');

    function render() {
      value = Math.max(Math.round(market * 0.4), Math.min(value, Math.round(market * 1.5)));
      if (amountEl) amountEl.innerHTML = '<sup>' + symbol + '</sup>' + Math.round(value).toLocaleString('en-US');
      if (hidden) hidden.value = money(value, symbol);
      var pct = market ? (value / market) * 100 : 0;
      if (pctEl) pctEl.textContent = Math.round(pct) + '% of market valuation';
      if (meterEl) meterEl.style.width = Math.max(4, Math.min(100, pct)) + '%';
      if (strengthEl) {
        strengthEl.classList.remove('is-weak', 'is-fair');
        if (pct >= 95) { strengthEl.textContent = '● Strong offer'; }
        else if (pct >= 85) { strengthEl.textContent = '● Fair offer'; strengthEl.classList.add('is-fair'); }
        else { strengthEl.textContent = '● Below market'; strengthEl.classList.add('is-weak'); }
      }
    }

    wrap.querySelectorAll('[data-ht-offer-step]').forEach(function (b) {
      b.addEventListener('click', function () {
        value += parseInt(b.getAttribute('data-ht-offer-step'), 10) * step;
        render();
      });
    });
    wrap.querySelectorAll('[data-ht-offer-preset]').forEach(function (b) {
      b.addEventListener('click', function () {
        value = parseFloat(b.getAttribute('data-ht-offer-preset'));
        render();
      });
    });
    render();
  }

  function bindFormUI(scope) {
    scope.querySelectorAll('[data-ht-form-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var panel = btn.nextElementSibling;
        if (panel) panel.classList.toggle('is-open');
      });
    });
  }

  function boot() {
    initNav();
    initDrawer();
    initAccordions();
    initGallery();
    initModal();
    bindOfferUI(document);
    bindFormUI(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
